// extracted by mini-css-extract-plugin
module.exports = {"filters":"Filters_filters__12Us1","close":"Filters_close__1MD5_","filter-group":"Filters_filter-group__3-26_"};